import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { DeleteReminder } from 'app/store/reminder/reminder.actions';
import { Activity } from 'ng2-app/modules/activity/models/activity/activity.model';

@Component({
    selector: 'activity-row-reminder',
    templateUrl: './activity-row-reminder.component.html',
    styleUrls: ['./activity-row-reminder.component.scss']
})
export class ActivityRowReminderComponent implements OnInit {
    @Input() activity: Activity;

    expired: boolean;

    constructor(
        private store: Store
    ) { }

    ngOnInit() {
        this.reminderExpired(this.activity.meta.expires * 1000);
    }

    reminderExpired($expiration) {
        const now = new Date;
        return this.expired = $expiration > now.getTime() ? false : true;
    }

    cancelReminder() {
        this.store.dispatch(new DeleteReminder(this.activity.meta.reminderId));
    }
}
